enum NotebookSortOptions {
    CreatedOnAscending = 0,
    CreatedOnDescending = 1,
    NameAscending = 2,
    NameDescending = 3,
}

export default NotebookSortOptions;
